module.exports = __webpack_public_path__ + "img/logo-PLI-tmp.caf2893e.svg";